import type { IDirRange, IFileSummary } from '../types'
import { get, post } from '@/utils/request'

/**
 * 获取文件摘要
 * @param data.fileId 文件ID
*/
interface IFileAbstract {
  fileId: number
}
export const getFileSummary = (data: IFileAbstract) => {
  return get<IFileSummary>({
    url: '/assistant/lib/file/getAssistantFileFullDigest',
    data,
  })
}

/**
 * 获取文件夹范围列表
 */
export const dirRange = (data: {
  workspaceId: number | null
  workspaceType: any
}) => {
  return post<IDirRange[]>({
    url: '/assistant/lib/dirGange',
    data,
  })
}

/**
 * 获取文件夹下的文件
 */

export const getDirFiles = (data: { dirId: string }) => {
  return post({
    url: '/assistant/lib/dirDocs',
    data,
  })
}

/**
 * 推荐问题查询(随机)
 */
export const getQuestionRandom = (data: { dirId: number }) => {
  return post<string[]>({
    url: '/assistant/lib/file/recommendQuestionRandom',
    data,
  })
}

/**
 *  获取文件夹摘要
 * @param data.dirID 文件夹ID
 */
export const getFolderDesign = (data: { dirId: number }) => {
  return get({
    url: '/assistant/lib/dir/assistant/getDigest',
    data,
  })
}

/**
 * 获取引用
*/
export interface IReferences {
  requestId: string
  page: string
  role: string
}

export interface IReferencesResponse {
  page: number
  content: {
    fileId: number
    fileName: string
    referenceText: string
    status: 0 | 1
  }
}
export const getReferences = (data: IReferences) => {
  return post<IReferencesResponse>({
    url: '/assistant/intelligentAssistant/answerRecord/reference', data,
  })
}
